// extracted by mini-css-extract-plugin
export default {"bid-cta-btn":"style_bid-cta-btn__12WVM","bidCtaBtn":"style_bid-cta-btn__12WVM"};